import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useFundTransferLogic } from './hooks/useFundTransferLogic';
import { FundTransferForm } from './FundTransferForm';

export const EddFundTransfer = () => {
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useFundTransferLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={tCommon('sectionTitles.businessActivity')}
        headingContainerCustomStyle='!mb-[16px]'>
        <FundTransferForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
